import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetBatchById } from "../../../apis/batches/get-batch-by-id";
import { useCloseBatch } from "../../../apis/batches/close-batch";
import { useRemoveOrderFromBatch } from "../../../apis/batches/remove-order-from-batch";
import { toast } from "react-toastify";

const useBatchDetails = () => {
    const { id } = useParams<{ id: string }>();
    const { data, isFetching: loading, refetch } = useGetBatchById(id);
    const { mutateAsync: closeBatch, isPending: isClosingBatch } = useCloseBatch();
    const { mutateAsync: removeOrderFromBatch, isLoading: isRemovingOrder } = useRemoveOrderFromBatch();

    const [orderToRemove, setOrderToRemove] = useState<string | null>(null);

    useEffect(() => {
        if (data) {
            console.log("Batch Details Response Data:", data);
        }
    }, [data]);

    const handleBatchClose = async () => {
        if (!id) return;
        try {
            await closeBatch(id);
            toast.success("Batch Closed Successfully");
            refetch();
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Couldn't close batch at this moment. Please try again later.");
        }
    };

    const handleConfirmRemoveOrder = async () => {
        if (!id || !orderToRemove) return;
        try {
            await removeOrderFromBatch({ batchId: id, serviceId: orderToRemove });
            setOrderToRemove(null);
            refetch();
        } catch (error: any) {
            // Error is handled in mutation's onError toast
        }
    };

    return {
        id,
        batchInfo: data?.batch,
        orders: data?.orders ?? [],
        pricing: data?.pricing,
        logs: data?.logs ?? [],
        loading,
        isClosingBatch,
        handleBatchClose,
        orderToRemove,
        setOrderToRemove,
        isRemovingOrder,
        handleConfirmRemoveOrder,
        refetch,
    };
};

export default useBatchDetails;
